import styled from "styled-components";

export const StyledWrapper = styled.div`
  display: grid;
  grid-template-rows: repeat(1fr);
  place-content: center;
`;
